import { FetchProjectPostFilterModel } from '../../shared/models/select';
import { ProjectPostPaginationModel } from './course-list.model';

export class FetchProjectPosts {
  static readonly type = '[Course List Project] FetchProjectPosts';
  constructor(public filters: FetchProjectPostFilterModel) {}
}

export class FetchProjectPostsWithSearchText {
  static readonly type =
    '[Course List Project] FetchProjectPostsWithSearchText';
  constructor(public filters: FetchProjectPostFilterModel) {}
}

export class UpdateProjectpostPagination {
  static readonly type = '[Course List Project] Update Pagination';
  constructor(public pagination?: ProjectPostPaginationModel) {}
}

export class GetCoursesValue {
  static readonly type = '[Course List Project] Fetch value';
  constructor() {}
}

export class GetCareerValue {
  static readonly type = '[Career List Project] Fetch value';
  constructor() {}
}

export class ResetCourseList {
  static readonly type =
    '[Course List Project] ResetCourseList';
  constructor() {}
}
